import { Drawer } from "antd";
import close from "./../../../../assets/images/close.svg";
import mail from "./../../../../assets/images/mail.svg";
import location from "./../../../../assets/images/Location-purple.svg";
import call from "./../../../../assets/images/call-purple.svg";
import googleLocationIcon from "./../../../../assets/images/google-location.svg";

const ContactSupport = ({ show, closePopup, agentDetails }: any) => {
  const { hospital_name, googleLocation } = agentDetails || {};
  const { address } = googleLocation;
  return (
    <Drawer
      placement="bottom"
      onClose={closePopup}
      closeIcon={false}
      open={show}
      height="auto"
      className="rounded-t-2xl overflow-hidden max-w-[450px] mx-auto"
      style={{ margin: "auto" }}
    >
      <div className="flex flex-col h-full">
        <div className="flex justify-between items-center">
          <div className="font-semibold text-lg">Contact Support</div>
          <img src={close} alt="close" onClick={closePopup} />
        </div>
      </div>
      <section className="flex justify-center mt-6 w-full">
        <div className="bg-[#FAFAFB] rounded-2xl p-6 min-w-[350px] shadow-sm flex flex-col gap-4 w-full">
          {/* Phone */}
          {agentDetails?.contact && (
            <div className="flex items-center gap-3 border-b border-gray-100 pb-3">
              <img src={call} alt="Phone" className="w-6 h-6 text-purple-500" />
              <a
                href={`tel:${agentDetails.contact}`}
                className="font-medium underline text-sm text-black"
              >
                {agentDetails.contact}
              </a>
            </div>
          )}
          {/* Email */}
          {agentDetails?.email && (
            <div className="flex items-center gap-3 border-b border-gray-100 py-3">
              <img src={mail} alt="Email" className="w-6 h-6 text-purple-500" />
              <a
                href={`mailto:${agentDetails.email}`}
                className="font-medium underline text-sm text-black"
              >
                {agentDetails.email}
              </a>
            </div>
          )}
          {/* Address */}
          <div className="flex items-start gap-3 pt-3">
            <img
              src={location}
              alt="Location"
              className="w-6 h-6 text-purple-500 mt-1"
            />
            <div>
              <div className="flex items-center gap-1">
                <span className="font-medium text-sm text-black">
                  {hospital_name}
                </span>
                {address?.googleMapsLink && (
                  <a
                    href={address?.googleMapsLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="ml-1 text-purple-500"
                  >
                    <img
                      src={googleLocationIcon}
                      alt={"google-location-icon"}
                    />
                  </a>
                )}
              </div>
              <div className="text-gray-600 text-xs font-normal mt-1">
                {address?.formatted}
              </div>
            </div>
          </div>
        </div>
      </section>
    </Drawer>
  );
};

export default ContactSupport;
